// extracted by mini-css-extract-plugin
export var addButton = "_ex-0";
export var border = "_ex-8";
export var check = "_ex-h";
export var danger = "_ex-6";
export var dropdownContainer = "_ex-1";
export var editModalBody = "_ex-j";
export var footerContainer = "_ex-i";
export var fullWidth = "_ex-a";
export var hide = "_ex-9";
export var icon = "_ex-3";
export var input = "_ex-7";
export var inputFlex = "_ex-b";
export var inputWrapper = "_ex-c";
export var manualFocus = "_ex-5";
export var optionButton = "_ex-4";
export var pillWrapper = "_ex-e";
export var pointer = "_ex-2";
export var showOverflow = "_ex-f";
export var tagsFlex = "_ex-d";
export var xButton = "_ex-g";